// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Category from "../Control.Category/index.js";
import * as Control_Monad_Except_Trans from "../Control.Monad.Except.Trans/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Function from "../Data.Function/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Identity from "../Data.Identity/index.js";
import * as Data_Int from "../Data.Int/index.js";
import * as Data_Map_Internal from "../Data.Map.Internal/index.js";
import * as Data_Newtype from "../Data.Newtype/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Traversable from "../Data.Traversable/index.js";
import * as Data_Tuple from "../Data.Tuple/index.js";
import * as Data_Tuple_T2 from "../Data.Tuple.T2/index.js";
import * as Data_Unfoldable from "../Data.Unfoldable/index.js";
import * as Foreign from "../Foreign/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Foreign_Object from "../Foreign.Object/index.js";
import * as Unscramble from "../Unscramble/index.js";
var applicativeExceptT = /* #__PURE__ */ Control_Monad_Except_Trans.applicativeExceptT(Data_Identity.monadIdentity);
var pure = /* #__PURE__ */ Control_Applicative.pure(applicativeExceptT);
var bind = /* #__PURE__ */ Control_Bind.bind(/* #__PURE__ */ Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity));
var toUnfoldable = /* #__PURE__ */ Foreign_Object.toUnfoldable(Data_Unfoldable.unfoldableArray);
var map = /* #__PURE__ */ Data_Functor.map(/* #__PURE__ */ Control_Monad_Except_Trans.functorExceptT(Data_Identity.functorIdentity));
var traverse = /* #__PURE__ */ Data_Traversable.traverse(Data_Traversable.traversableArray)(applicativeExceptT);
var decodeT2 = /* #__PURE__ */ Data_Tuple_T2.decodeT2(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.foreignDecode)));
var toUnfoldable1 = /* #__PURE__ */ Data_Map_Internal.toUnfoldable(Data_Unfoldable.unfoldableArray);
var fromFoldable = /* #__PURE__ */ Foreign_Object.fromFoldable(Data_Foldable.foldableArray);
var map1 = /* #__PURE__ */ Data_Functor.map(Data_Functor.functorArray);
var encodeT2 = /* #__PURE__ */ Data_Tuple_T2.encodeT2(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.foreignEncode)));
var SerializedMap = function (x) {
    return x;
};
var AsJSONKeyString = /* #__PURE__ */ (function () {
    function AsJSONKeyString(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    AsJSONKeyString.create = function (value0) {
        return function (value1) {
            return new AsJSONKeyString(value0, value1);
        };
    };
    return AsJSONKeyString;
})();
var AsJSONKeyValue = /* #__PURE__ */ (function () {
    function AsJSONKeyValue(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    AsJSONKeyValue.create = function (value0) {
        return function (value1) {
            return new AsJSONKeyValue(value0, value1);
        };
    };
    return AsJSONKeyValue;
})();
var asJSONKeyMaybe = function (dictEncode) {
    var encode = Foreign_Generic_Class.encode(Foreign_Generic_Class.maybeEncode(dictEncode));
    return function (dictDecode) {
        return {
            asJSONKey: new AsJSONKeyValue(encode, Foreign_Generic_Class.decode(Foreign_Generic_Class.maybeDecode(dictDecode)))
        };
    };
};
var asJSONKeyInt = /* #__PURE__ */ (function () {
    return {
        asJSONKey: new AsJSONKeyString(Data_Show.show(Data_Show.showInt), (function () {
            var $122 = Data_Either.either((function () {
                var $125 = Foreign.fail(Data_Identity.monadIdentity);
                return function ($126) {
                    return $125(Foreign.ForeignError.create($126));
                };
            })())(pure);
            var $123 = Data_Either.note("Invalid Int");
            return function ($124) {
                return $122($123(Data_Int.fromString($124)));
            };
        })())
    };
})();
var udecodeMap = function (dictOrd) {
    return function (dictFromJSONKey) {
        var decodeMap1 = Unscramble.decodeMap(dictFromJSONKey)(dictOrd);
        return function (dictDecode) {
            return decodeMap1(dictDecode);
        };
    };
};
var showMap = function (dictShow) {
    var showMap1 = Data_Map_Internal.showMap(dictShow);
    return function (dictShow1) {
        return showMap1(dictShow1);
    };
};
var semigroupMap = function (dictOrd) {
    var union = Data_Map_Internal.union(dictOrd);
    return {
        append: function (v) {
            return function (v1) {
                return union(v)(v1);
            };
        }
    };
};
var ordMap = function (dictOrd) {
    var ordMap1 = Data_Map_Internal.ordMap(dictOrd);
    return function (dictOrd1) {
        return ordMap1(dictOrd1);
    };
};
var newtypeMap = {
    Coercible0: function () {
        return undefined;
    }
};
var monoidMap = function (dictOrd) {
    var semigroupMap1 = semigroupMap(dictOrd);
    return {
        mempty: Data_Map_Internal.empty,
        Semigroup0: function () {
            return semigroupMap1;
        }
    };
};
var functorMap = Data_Map_Internal.functorMap;
var fromSerializedMap = /* #__PURE__ */ Data_Newtype.unwrap();
var fromJSONKeyMap = function (dictOrd) {
    var udecodeMap1 = udecodeMap(dictOrd);
    return function (dictFromJSONKey) {
        var udecodeMap2 = udecodeMap1(dictFromJSONKey);
        return function (dictDecode) {
            return {
                fromJSONKey: Unscramble.defaultFromJSONKeyValue(udecodeMap2(dictDecode))
            };
        };
    };
};
var foldableWithIndexMap = Data_Map_Internal.foldableWithIndexMap;
var foldableMap = Data_Map_Internal.foldableMap;
var eqMap = function (dictEq) {
    var eqMap1 = Data_Map_Internal.eqMap(dictEq);
    return function (dictEq1) {
        return eqMap1(dictEq1);
    };
};
var asJSONKeyString = /* #__PURE__ */ (function () {
    return {
        asJSONKey: new AsJSONKeyString(Control_Category.identity(Control_Category.categoryFn), pure)
    };
})();
var asJSONKeyMap = function (dictOrd) {
    return function (dictAsJSONKey) {
        return function (dictEncode) {
            var encode = Foreign_Generic_Class.encode(dictEncode);
            return function (dictDecode) {
                return {
                    asJSONKey: new AsJSONKeyValue(encode, Foreign_Generic_Class.decode(dictDecode))
                };
            };
        };
    };
};
var asJSONKey = function (dict) {
    return dict.asJSONKey;
};
var decodeMap = function (dictOrd) {
    var fromFoldable1 = Data_Map_Internal.fromFoldable(dictOrd)(Data_Foldable.foldableArray);
    return function (dictAsJSONKey) {
        var asJSONKey1 = asJSONKey(dictAsJSONKey);
        return function (dictDecode) {
            var decode = Foreign_Generic_Class.decode(Foreign_Generic_Class.objectDecode(dictDecode));
            return function (dictGenericDecodeArgs) {
                var decode1 = Foreign_Generic_Class.decode(Foreign_Generic_Class.arrayDecode(decodeT2(dictGenericDecodeArgs)));
                return {
                    decode: function (f) {
                        if (asJSONKey1 instanceof AsJSONKeyString) {
                            return bind(decode(f))(function (obj) {
                                var kvs = toUnfoldable(obj);
                                return map(function ($127) {
                                    return SerializedMap(fromFoldable1($127));
                                })(traverse(function (v1) {
                                    return map(Data_Function.flip(Data_Tuple.Tuple.create)(v1.value1))(asJSONKey1.value1(v1.value0));
                                })(kvs));
                            });
                        };
                        if (asJSONKey1 instanceof AsJSONKeyValue) {
                            return bind(decode1(f))(function (kvs) {
                                return map(function ($128) {
                                    return SerializedMap(fromFoldable1($128));
                                })(traverse(function (v1) {
                                    return map(Data_Function.flip(Data_Tuple.Tuple.create)(v1.value1))(asJSONKey1.value1(v1.value0));
                                })(kvs));
                            });
                        };
                        throw new Error("Failed pattern match at Data.Map.Serialized (line 67, column 5 - line 74, column 105): " + [ asJSONKey1.constructor.name ]);
                    }
                };
            };
        };
    };
};
var encodeMap = function (dictAsJSONKey) {
    var asJSONKey1 = asJSONKey(dictAsJSONKey);
    return function (dictEncode) {
        var encode = Foreign_Generic_Class.encode(Foreign_Generic_Class.objectEncode(dictEncode));
        return function (dictGenericEncodeArgs) {
            var encode1 = Foreign_Generic_Class.encode(Foreign_Generic_Class.arrayEncode(encodeT2(dictGenericEncodeArgs)));
            return {
                encode: function (v) {
                    var kvs = toUnfoldable1(v);
                    if (asJSONKey1 instanceof AsJSONKeyString) {
                        return encode(fromFoldable(map1(function (v2) {
                            return new Data_Tuple.Tuple(asJSONKey1.value0(v2.value0), v2.value1);
                        })(kvs)));
                    };
                    if (asJSONKey1 instanceof AsJSONKeyValue) {
                        return encode1(map1(function (v2) {
                            return new Data_Tuple_T2.T2(asJSONKey1.value0(v2.value0), v2.value1);
                        })(kvs));
                    };
                    throw new Error("Failed pattern match at Data.Map.Serialized (line 61, column 7 - line 63, column 108): " + [ asJSONKey1.constructor.name ]);
                }
            };
        };
    };
};
export {
    SerializedMap,
    asJSONKey,
    AsJSONKeyString,
    AsJSONKeyValue,
    fromSerializedMap,
    newtypeMap,
    eqMap,
    ordMap,
    showMap,
    semigroupMap,
    monoidMap,
    functorMap,
    foldableMap,
    udecodeMap,
    foldableWithIndexMap,
    asJSONKeyString,
    asJSONKeyMap,
    asJSONKeyMaybe,
    asJSONKeyInt,
    encodeMap,
    decodeMap,
    fromJSONKeyMap
};
